<!-- moved: documents/upload -->
<div class="upload-container" id="upload-container">
  <div class="upload-header" id="upload-header">
    <h1 class="upload-title" id="upload-title">{{ translate('upload.title') }}</h1>
  </div>

  <app-plan-limit-banner
    *ngIf="planLimitError"
    [error]="planLimitError"
    (dismissed)="dismissPlanLimit()">
  </app-plan-limit-banner>

  <div class="upload-content" id="upload-content">
    <!-- Zona de arrastrar y soltar -->
    <div class="drop-zone" [class.has-files]="files.length > 0" #dropZone id="drop-zone">
      <div class="drop-zone-content" id="drop-zone-content">
        <i class="fas fa-cloud-upload-alt" id="icon-cloud-upload"></i>
        <h2 id="drop-zone-drag">{{ translate('upload.drag') }}</h2>
        <p id="drop-zone-formats">{{ translate('upload.formats') }}</p>
        <button type="button" class="btn btn-primary" (click)="openFileDialog()" id="btn-open-file-dialog">
          <i class="fas fa-folder-open" id="icon-folder-open"></i>
          {{ translate('upload.select') }} 
        </button>
        <input type="file" #fileInput multiple hidden (change)="onFileSelected($event)" id="input-file">
      </div>
    </div>

    <!-- Opciones de subida -->
    <div class="upload-options glass-effect" *ngIf="files.length > 0" id="upload-options">
      <form [formGroup]="uploadForm" id="form-upload">
        <div class="form-group" id="form-group-process-immediately">
          <div class="form-check" id="form-check-process-immediately">
            <input class="form-check-input" type="checkbox" id="processImmediately"
              formControlName="processImmediately">
            <label class="form-check-label" for="processImmediately" id="label-process-immediately">
              {{ translate('upload.process_immediately') }}
            </label>
          </div>
        </div>

        <div class="form-group" id="form-group-folder-name">
          <label for="folderName" id="label-folder-name">{{ translate('breadcrumbs.input.label') }}</label>
          <app-breadcrumb-input></app-breadcrumb-input>
        </div>

        <div class="form-group" id="form-group-tags">
          <label id="label-tags">{{ translate('upload.tags') }}</label>
          <div class="tags-input" id="tags-input">
            <div class="tags-list" id="tags-list">
              <div class="tag" *ngFor="let tag of uploadForm.get('tags')?.value; let i = index" id="tag-{{i}}">
                <span id="tag-value-{{i}}">{{ tag }}</span>
                <button type="button" class="tag-remove" (click)="removeTag(tag)" id="btn-remove-tag-{{i}}">
                  <i class="fas fa-times" id="icon-remove-tag-{{i}}"></i>
                </button>
              </div>
            </div>
            <div class="tags-add" id="tags-add">
              <input type="text" class="form-control" [(ngModel)]="currentTag" [ngModelOptions]="{standalone: true}"
                [placeholder]="translate('upload.add_tag')" (keyup.enter)="addTag()" id="input-add-tag">
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="addTag()" id="btn-add-tag">
                <i class="fas fa-plus" id="icon-add-tag"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="form-group" id="form-group-role-id">
          <label for="roleId" id="label-role-id">
            <i class="fas fa-user-shield"></i> {{ translate('upload.role_id') || 'Rol de acceso' }}
          </label>
          <select 
            class="form-control" 
            id="roleId" 
            formControlName="roleId"
            [disabled]="rolesLoading">
            <option value="" disabled>{{ translate('upload.select_role') || '-- Selecciona un rol --' }}</option>
            <option *ngFor="let role of roles" [value]="role.id || role.name">
              {{ role.label || role.name }}
            </option>
          </select>
          <small class="form-text text-muted" *ngIf="rolesLoading">
            <i class="fas fa-spinner fa-spin"></i> {{ translate('upload.loading_roles') || 'Cargando roles...' }}
          </small>
          <small class="form-text text-danger" *ngIf="rolesError">
            {{ rolesError }}
          </small>
          <small class="form-text text-danger" *ngIf="uploadForm.get('roleId')?.invalid && uploadForm.get('roleId')?.touched">
            {{ translate('upload.role_id_required') || 'El rol es obligatorio' }}
          </small>
          <small class="form-text text-muted" *ngIf="!rolesLoading && !rolesError && uploadForm.get('roleId')?.valid">
            {{ translate('upload.role_id_help') || 'Selecciona el rol con acceso a este documento' }}
          </small>
        </div>
      </form>
    </div>

    <!-- Lista de archivos -->
    <div class="files-list" *ngIf="files.length > 0" id="files-list">
      <div class="files-header" id="files-header">
        <h3 id="files-to-upload">{{ translate('upload.files_to_upload') }} ({{ files.length }})</h3>
        <div class="files-actions" id="files-actions">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearCompleted()"
            *ngIf="hasCompletedFiles()" id="btn-clear-completed">
            <i class="fas fa-trash-alt" id="icon-clear-completed"></i> {{ translate('upload.clear_completed') }}
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="uploadFiles()"
            [disabled]="isUploading || files.length === 0 || isUploadBlocked" id="btn-upload-all">
            <i class="fas fa-upload" id="icon-upload-all"></i> {{ translate('upload.upload_all') }}
          </button>
        </div>
      </div>

      <div class="file-item" *ngFor="let file of files; let fileIdx = index" [ngClass]="file.status" id="file-item-{{fileIdx}}">
        <div class="file-icon" [style.color]="getFileColor(file.file.name)" id="file-icon-{{fileIdx}}">
          <i class="fas" [ngClass]="getFileIcon(file.file.name)" id="file-icon-inner-{{fileIdx}}"></i>
        </div>

        <div class="file-info" id="file-info-{{fileIdx}}">
          <div class="file-name" id="file-name-{{fileIdx}}">{{ file.file.name }}</div>
          <div class="file-size" id="file-size-{{fileIdx}}">{{ (file.file.size / 1024).toFixed(1) }} KB</div>

          <div class="file-tags" *ngIf="file.tags.length > 0" id="file-tags-{{fileIdx}}">
            <div class="file-tag" *ngFor="let tag of file.tags; let tagIdx = index" id="file-tag-{{fileIdx}}-{{tagIdx}}">
              <span id="file-tag-value-{{fileIdx}}-{{tagIdx}}">{{ tag }}</span>
              <button type="button" class="tag-remove" (click)="removeTagFromFile(file.id, tag)" id="btn-remove-file-tag-{{fileIdx}}-{{tagIdx}}">
                <i class="fas fa-times" id="icon-remove-file-tag-{{fileIdx}}-{{tagIdx}}"></i>
              </button>
            </div>
          </div>

          <div class="file-progress" *ngIf="file.status === 'uploading'" id="file-progress-{{fileIdx}}">
            <div class="progress" id="progress-{{fileIdx}}">
              <div class="progress-bar" [style.width.%]="file.progress" id="progress-bar-{{fileIdx}}"></div>
            </div>
            <div class="progress-text" id="progress-text-{{fileIdx}}">{{ file.progress }}%</div>
          </div>

          <div class="file-status" *ngIf="file.status === 'created' || file.status === 'error' || file.status === 'blocked'" id="file-status-{{fileIdx}}">
            <i class="fas" [ngClass]="file.status === 'created' ? 'fa-check-circle' : (file.status === 'blocked' ? 'fa-lock' : 'fa-exclamation-circle')" id="icon-file-status-{{fileIdx}}"></i>
            <span id="file-message-{{fileIdx}}">{{ file.message }}</span>
          </div>
        </div>

        <div class="file-actions" id="file-actions-{{fileIdx}}">
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFile(file.id)"
            *ngIf="file.status !== 'uploading'" id="btn-remove-file-{{fileIdx}}">
            <i class="fas fa-times" id="icon-remove-file-{{fileIdx}}"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isUploading" class="upload-spinner-overlay" id="upload-spinner-overlay">
    <mat-spinner diameter="60" id="mat-spinner"></mat-spinner>
    <div class="upload-spinner-text" id="upload-spinner-text">{{ translate('upload.processing') }}</div>
  </div>
</div>
